import React, {FormEvent, useContext, useState} from "react";
import {Icon, message} from "antd";
import {AccountPasswordLoginFormProps, withAccountPasswordLoginForm} from "../../hoc/withAccountPasswordLoginForm";
import {useIntl} from "react-intl";

const BasAccountPasswordLoginForm: React.FC<AccountPasswordLoginFormProps> = (props) => {
    let intl = useIntl();
    const {username, password, changeUsername, changePassword, loginLoading} = props
    return (
            <>
                <div className={'input'}>
                    <Icon type="user" />
                    <input
                        placeholder={intl.formatMessage({id: "用户名"})}
                        value={username}
                        onChange={changeUsername}
                    />
                </div>
                <div className={'input'}>
                    <Icon type="unlock" />
                    <input
                        placeholder={intl.formatMessage({id: "密码"})}
                        type="password"
                        value={password}
                        onChange={changePassword}
                    />
                </div>
                <button type="submit" className={'submit'} disabled={loginLoading}>
                    {loginLoading ? <Icon type="loading" /> : ''}{intl.formatMessage({id: "登 录"})}
                </button>
            </>
    )
}

export default withAccountPasswordLoginForm(BasAccountPasswordLoginForm)
